import React from 'react';
import { IconS24Star24, IconS24Star24Filled, IconS24Star24Half } from '@is24/cosma-ui-icons';
var AgentRatings = function AgentRatings(_ref) {
  var evaluations = _ref.evaluations;
  if (!evaluations) {
    return null;
  }
  var averageRating = evaluations.averageRating,
    overallNumberOfEvaluations = evaluations.overallNumberOfEvaluations;
  if (!averageRating || !overallNumberOfEvaluations || overallNumberOfEvaluations <= 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "font-body-medium-bold grid-item grid-flex grid-align-center",
    "data-testid": "average-rating"
  }, /*#__PURE__*/React.createElement("div", {
    className: "margin-top-xs",
    style: {
      color: '#F2CA26'
    }
  }, averageRating >= 4 ? /*#__PURE__*/React.createElement(IconS24Star24Filled, null) : averageRating > 2 ? /*#__PURE__*/React.createElement(IconS24Star24Half, null) : /*#__PURE__*/React.createElement(IconS24Star24, null)), /*#__PURE__*/React.createElement("span", {
    className: "margin-left-xs palm-margin-left-s",
    "data-testid": "rating-value"
  }, averageRating.toFixed(1).replace('.', ','), /*#__PURE__*/React.createElement("span", null, " (", overallNumberOfEvaluations, ")")));
};
export default AgentRatings;